(function(){
    angular
        .module('app')
        .directive('ngFilesan', filesAn);

        filesAn.$inject = ['$timeout'];
        function filesAn($timeout){
            return {
            restrict:'A',
            replace: true,
        	transclude: true,
   			scope: { control : "=" },
            link: function (scope, element, $attrs) {
                return $timeout(function () {
                    var value = $attrs.value;
                    var $element = $(element);
                   	var button = $element, interval;
                   	var textButton = 'Upload Files';
                   	button.text(textButton);
                   	scope.parentScope =  scope.control;
                   	console.log($attrs.value);
                   	scope.parentScope.value = $attrs.value;
                   	scope.parentScope.fieldname = $attrs.fieldname;
                   	scope.parentScope.node_id = $attrs.node_id;
                   	//console.log($attrs.sizes);
                   	if($attrs.sizes!=""){
                   		scope.parentScope.sizes = JSON.parse($attrs.sizes);
                   	}
                   	//console.log(scope.parentScope.sizes);
                   	scope.parentScope.maxFiles = $attrs.maxfiles;
                   	console.log(scope);
                   	scope.parentScope.init();
                   	var baseurl = $('body').attr("data-baseurl");
					new AjaxUpload(button,{
						action: baseurl+'/backend/altcrm/foto/subir', 
						name: 'image[]',
						data:{ "crop" : scope.parentScope.sizes},
						onSubmit : function(file, ext){
							
							button.text('Subiendo');

							// desabilitar el boton
							this.disable();
							
							interval = window.setInterval(function(){
								var text = button.text();
								if (text.length < 11){
									button.text(text + '.');					
								} else {
									button.text('Subiendo');				
								}
							}, 200);
						},
						onComplete: function(file, response){
							//button.text('Subir Archivos');
										
							window.clearInterval(interval);
						
							// Habilitar boton otra vez
							this.enable();
							
							// Añadiendo las imagenes a mi lista
							response = JSON.parse(response);
							button.text(textButton);
							//console.log(response.fotos);
							for(var cont=0;cont<response.fotos.length;cont++){
								if(response.fotos[cont].crops.length>0){
									scope.parentScope.cropFoto(response.fotos[cont]);
								}
							}
							scope.parentScope.pushFotos(response.fotos);
							if(scope.parentScope.fieldname==""){
								scope.$parent.refrescarLista("");
							}
	
						}
					});
                });
            }
          }
      }
})();